import { CampaignType, Locale } from 'scripts/type'

const nameMapping = {
  [Locale.ZhCn]: {
    [CampaignType.SURVEY]: '问卷',
    [CampaignType.FEEDBACK]: '评价',
    [CampaignType.REPLY]: '回复',
    [CampaignType.NOTIFICATION]: '通知',
  },
  [Locale.Tw]: {
    [CampaignType.SURVEY]: '問卷',
    [CampaignType.FEEDBACK]: '評價',
    [CampaignType.REPLY]: '廻複',
    [CampaignType.NOTIFICATION]: '通知',
  },
  [Locale.En]: {
    [CampaignType.SURVEY]: 'Survey',
    [CampaignType.FEEDBACK]: 'Feedback',
    [CampaignType.REPLY]: 'Reply',
    [CampaignType.NOTIFICATION]: 'Notification',
  },
}

export default function getCampaignTypeName(type: CampaignType, locale?: Locale) {
  return nameMapping[locale ?? Locale.ZhCn][type]
}
